import IconButton from '@/components/Buttons/IconButton';
import styled from '@emotion/styled';

export const ControlIconButton = styled(IconButton)`
    color: ${({ theme }) => theme.colors.black[900]} !important;
    background-color: #fff !important;
    border: 1px solid ${({ theme }) => theme.colors.black[300]};
    border-radius: 8px;
    width: 30px;
    height: 30px;

    :focus {
        outline: none;
    }

    :hover {
        background-color: ${({ theme }) => theme.colors.black[200]} !important;
    }
`;
